import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { WalletIcon, MapIcon, RefreshCcwIcon, MonitorOffIcon } from 'lucide-react';
const problems = [{
  icon: WalletIcon,
  text: 'Trabajas duro pero sientes que tu esfuerzo no se refleja en tu bolsillo'
}, {
  icon: MapIcon,
  text: 'Quieres algo propio pero no sabes por dónde empezar'
}, {
  icon: RefreshCcwIcon,
  text: 'Te sientes atrapada en una rutina que no te lleva a ningún lado'
}, {
  icon: MonitorOffIcon,
  text: 'Has visto opciones online pero todo parece complicado o poco claro'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function ProblemSection() {
  return <section className="bg-cream py-16 md:py-24" data-id="element-117">
      <div className="max-w-6xl mx-auto px-4" data-id="element-118">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-119">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-4" data-id="element-120">
            ¿Te suena familiar?
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto rounded-full" data-id="element-121" />
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-122">
          {problems.map((problem, index) => <motion.div key={index} variants={itemVariants} className="bg-white p-8 rounded-2xl shadow-sm border border-beige flex items-start gap-4" data-id="element-123">
              <div className="bg-cream p-3 rounded-xl text-gold shrink-0" data-id="element-124">
                <problem.icon className="w-6 h-6" data-id="element-125" />
              </div>
              <p className="text-navy/80 text-lg leading-relaxed" data-id="element-126">
                {problem.text}
              </p>
            </motion.div>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.8
      }} className="text-center mt-16" data-id="element-127">
          <p className="text-xl md:text-2xl font-medium text-navy" data-id="element-128">
            No estás sola. Y no es tu culpa. <br className="hidden md:block" data-id="element-129" />
            <span className="text-gold" data-id="element-130">Solo necesitas una ruta clara.</span>
          </p>
        </motion.div>
      </div>
    </section>;
}